import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Admin_login from "./Pages/Admin/Admin_login";
import Superadmin_login from "./Pages/Superadmin/Superadmin_login";
import Superadmin_dashboard from "./Pages/Superadmin/Superadmin_dashboard";
import Admin_dashboard from "./Pages/Admin/Admin_dashboard";
import Admin_sidebar from "./Layouts/Admin_layout/Admin_sidebar";
import Superadmin_sidebar from "./Layouts/Superadmin_layout/Superadmin_sidebar";
import Vendors from "./Pages/Superadmin/Vendors";
import Field_Officer from "./Pages/Admin/FieldOfficers";
import Farmers from "./Pages/Admin/Farmers";
import Superadmin_ResetPassword from "./Pages/Superadmin/Superadmin_ResetPassword";
import Admin_Resetpassword from "./Pages/Admin/Admin_Resetpassword";
import FarmerDetails from "./Pages/Admin/FarmerDetails";
import FarmersData from "./Pages/Superadmin/FarmersData";
import Locations from "./Pages/Admin/Locations";
import Profile from "./Pages/Admin/Profile";
import FarmerDetailsData from "./Pages/Superadmin/FarmerDetailsData";
import SuperAdminForgotPassword from "./Pages/Superadmin/SuperAdminForgotPassword";
import ResetNewPassword from "./Pages/Superadmin/ResetNewPassword";
import AdminForgotPassword from "./Pages/Admin/AdminForgotPassword";
import AdminResetNewPassword from "./Pages/Admin/AdminResetNewPassword";
import FieldOfficersDetails from "./Pages/Admin/FieldOfficersDetails";
import AllDetails from "./Pages/Superadmin/AllDetails";
import StatusFieldOfficers from "./Pages/Superadmin/StatusFieldOfficers";
import Filedofficercheckin from "./Pages/Admin/Filedofficer_checkin";
import Fields from "./Pages/Admin/Fields";
import FarmMaintenance from "./Pages/Admin/FarmMaintenance";


const SuperadminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Superadmin_sidebar />}>
        <Route index element={<Superadmin_dashboard />} />
        <Route
          path="Superadmin_ResetPassword"
          element={<Superadmin_ResetPassword />}
        />
        <Route path="Dashboard" element={<Superadmin_dashboard />} />
        <Route path="Vendors" element={<Vendors />} />
        <Route path="AllDetails/:id" element={<AllDetails />} />
        <Route
          path="StatusFieldOfficers/:id"
          element={<StatusFieldOfficers />}
        />
        <Route path="Fields/:id" element={<FarmersData />} />
        <Route path="FieldDetails" element={<FarmerDetailsData />} />
        <Route path="*" element={<Navigate to="/superadmin/Dashboard" replace />} />
      </Route>
    </Routes>
  );
};

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Admin_sidebar />}>
        <Route index element={<Admin_dashboard />} />
        <Route path="Profile" element={<Profile />} />
        <Route path="Admin_Resetpassword" element={<Admin_Resetpassword />} />
        <Route path="Dashboard" element={<Admin_dashboard />} />
        <Route path="FieldOfficers" element={<Field_Officer />} />
        <Route
          path="FieldOfficerDetails/:hash"
          element={<FieldOfficersDetails />}
        />
        <Route
          path="fieldofficerscheckins"
          element={<Filedofficercheckin />}
        />
        <Route path="Farmers" element={<Farmers />} />
        <Route
          path="Fields/FieldDetails/:hash"
          element={<FarmerDetails />}
        />
        <Route path="Fields" element={<Fields />} />
        <Route path="Fields/:farmer_hash" element={<Fields />} />
        <Route path="Locations" element={<Locations />} />
        <Route path="FarmMaintenance" element={<FarmMaintenance />} />
        <Route path="*" element={<Navigate to="/admin/Dashboard" replace />} />
      </Route>
    </Routes>
  );
};

function App() {
  const [triggerRefresh, setTriggerRefresh] = useState();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  let authenticated = false;

  if (token) {
    authenticated = true;
  }

  if (!authenticated) {
    return (
      <BrowserRouter>
        <Routes>
          <Route
            path="/superadmin"
            element={<Superadmin_login setTriggerRefresh={setTriggerRefresh} />}
          />
          <Route
            path="/superadmin/superAdminForgotPassword"
            element={<SuperAdminForgotPassword />}
          />
          <Route
            path="superadmin/ResetNewPassword/:email"
            element={<ResetNewPassword />}
          />
          <Route
            path="/admin"
            element={<Admin_login setTriggerRefresh={setTriggerRefresh} />}
          />
          <Route
            path="/admin/AdminForgotPassword"
            element={<AdminForgotPassword />}
          />
          <Route
            path="/admin/AdminResetNewPassword/:email"
            element={<AdminResetNewPassword />}
          />
          <Route
            path="/superadmin/*"
            element={<Navigate to={"/superadmin"} />}
          />
          <Route path="/admin/*" element={<Navigate to={"/admin"} />} />
          <Route path="*" element={<Navigate to={"/admin"} />} />
        </Routes>
      </BrowserRouter>
    );
  } else if (role === "Admin" && authenticated) {
    return (
      <>
        <BrowserRouter>
          <Routes>
            <Route path="/superadmin/*" element={<SuperadminRoutes />} />
            <Route
              path="*"
              element={<Navigate to={"/superadmin/Dashboard"} />}
            />
          </Routes>
        </BrowserRouter>
      </>
    );
  } else if (role === "Vendor" && authenticated) {
    return (
      <>
        <BrowserRouter>
          <Routes>
            <Route path="/admin/*" element={<AdminRoutes />} />
            <Route path="*" element={<Navigate to={"/admin/Dashboard"} />} />
          </Routes>
        </BrowserRouter>
      </>
    );
  }
}

export default App;
